import { render, staticRenderFns } from "./edutalk-lich-tu-van.vue?vue&type=template&id=5b81017e"
import script from "./edutalk-lich-tu-van.vue?vue&type=script&lang=js"
export * from "./edutalk-lich-tu-van.vue?vue&type=script&lang=js"
import style0 from "./edutalk-lich-tu-van.vue?vue&type=style&index=0&id=5b81017e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports